<template>
  <section
    class="department-wrapper"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div class="pane-title">
      新增应急企业邀请
    </div>
    <div class="tab-pane-content">
      <!--应急企业 start-->
      <div class="left">
        <!-- <department-manage></department-manage> -->
        <section class="department-manage">
          <div class="section-title">应急企业</div>
          <div class="section-tool-bar">应急企业：{{ count }}</div>
          <div class="section-content">
            <e6-tree
              v-show="departmentTreeList.length"
              ref="departmentTree"
              :list.sync="departmentTreeList"
              is-open
              issingleleaf
            ></e6-tree>
            <!-- <e6-nodata v-if="!departmentTreeList.includeslength" size="mini"></e6-nodata> -->
          </div>
        </section>
      </div>
      <!--部门架构 end-->

      <!--待邀请应急企业 start-->
      <div class="middle">
        <div class="section-title">待邀请应急企业</div>
        <div class="section-tool-bar">
          <el-checkbox
            v-model="leftCheckedAll"
            :indeterminate="leftIndeterminate"
            @change="handleLeftCheckedAll"
          >
            全选
          </el-checkbox>
          <el-popover
            trigger="hover"
            width="200"
            placement="bottom"
            popper-class="department-popper"
          >
            <ul class="select-list">
              <li
                v-for="(item, index) in leftCheckedData"
                :key="index + '-' + item.vehicleId"
              >
                <span :title="item.label">{{ item.label }}</span>
                <i
                  class="iconfont e6-icon-delete_line"
                  @click="handleDeleteLeftChecked(item)"
                ></i>
              </li>
              <li v-if="!leftCheckedData.length" class="popover-nodata">
                您未选择任何待邀请应急企业
              </li>
            </ul>
            <span slot="reference" class="checked-number">
              {{ `${leftCheckedData.length} / ${leftDataTotal}` }}
            </span>
          </el-popover>
          <span
            class="checked-clear"
            @click="handleLeftClearAll('待邀请应急企业')"
          >
            清空
          </span>
          <div class="filter">
            <el-input
              v-model="leftFilterText"
              size="small"
              clearable
              placeholder="企业名称"
              class="filter-operate"
              @keyup.enter.native="handleLeftFilter"
            >
              <el-button
                slot="append"
                icon="e6-icon-search_line"
                @click="handleLeftFilter"
              ></el-button>
            </el-input>
          </div>
        </div>

        <div class="section-content">
          <e6-tree
            v-show="leftData.length"
            ref="departmentTree"
            :list.sync="leftData"
            is-check
            is-open
            issingleleaf
            disabledNoCheck
            :clickAndCheckCall="false"
            :func="handleLeftGetLimb"
            :chkfunc="handleLefGetNode"
          ></e6-tree>
          <!-- <e6-nodata
          v-if="!leftData.length"
          size="mini"
          :search="leftIsSearch"
          :text="leftNodataText"
        ></e6-nodata> -->
        </div>
      </div>
      <!--待邀请应急企业 end-->

      <!--穿梭箭头 start-->
      <div class="arrow-group">
        <i
          title="将待邀请应急企业分配到非应急企业"
          class="e6-icon-arrow-l_line active"
          @click="handleInsert"
        ></i>
        <i
          title="将非应急企业分配到待邀请应急企业"
          class="e6-icon-arrow-r_line active"
          @click="handleUnbind"
        ></i>
      </div>
      <!--穿梭箭头 end-->

      <!--非应急企业/全部 start-->
      <div class="right">
        <div class="section-title">非应急企业</div>
        <div class="section-tool-bar">
          <el-checkbox
            v-model="rightCheckedAll"
            :indeterminate="rightIndeterminate"
            @change="handleRightCheckedAll"
          >
            全选
          </el-checkbox>
          <el-popover
            trigger="hover"
            width="200"
            placement="bottom"
            popper-class="department-popper"
          >
            <ul class="select-list">
              <li
                v-for="(item, index) in rightCheckedData"
                :key="index + '-' + item.vehicleId"
              >
                <span :title="item.label">{{ item.label }}</span>
                <i
                  class="iconfont e6-icon-delete_line"
                  @click="handleDeleteRightChecked(item)"
                ></i>
              </li>
              <li v-if="!rightCheckedData.length" class="popover-nodata">
                您未选择任何非应急企业
              </li>
            </ul>
            <span slot="reference" class="checked-number">
              {{ `${rightCheckedData.length} / ${rightDataTotal}` }}
            </span>
          </el-popover>
          <span
            class="checked-clear"
            @click="handleRightClearAll('非应急企业')"
          >
            清空
          </span>
          <div class="filter">
            <el-input
              v-model="rightFilterText"
              size="small"
              clearable
              placeholder="企业名称"
              class="filter-operate"
              @keyup.enter.native="handleRightFilter"
            >
              <el-button
                slot="append"
                icon="e6-icon-search_line"
                @click="handleRightFilter"
              ></el-button>
            </el-input>
          </div>
        </div>

        <div class="section-content">
          <e6-tree
            v-show="rightData.length"
            ref="departRightTree"
            :list.sync="rightData"
            is-check
            is-open
            issingleleaf
            disabledNoCheck
            :clickAndCheckCall="false"
            :func="handleRightGetLimb"
            :chkfunc="handleRightGetNode"
          ></e6-tree>
        </div>
      </div>
      <!--非应急企业/全部 end-->
    </div>
    <!-- 底部操作按钮 -->
    <div class="pane-btn">
      <el-button type="primary" size="small" @click="handleSubmit()"
        >确定</el-button
      >
      <el-button
        size="small"
        @click="$router.push('emergencyManageCompanyList')"
        >取消</el-button
      >
    </div>
  </section>
</template>

<script>
// Api
import { saveCompanyData } from "@/api/emergencyManage/company";

// Mixins
import department from "@/mixins/department";

// Components
import e6Tree from "e6-tree";
// import DepartmentManage from "./departmentManage";

export default {
  name: "departmentEquipManage",

  mixins: [department],

  components: { e6Tree },

  data() {
    return {};
  },

  methods: {
    // 分待邀请应急企业 ← 非应急企业
    handleInsert() {
      if (!this.rightCheckedData.length) {
        this.$message.warning("请选择非应急企业数据");
        return;
      }
      this.dataMove(this.leftData, this.rightCheckedData);
      this.itselfDelete(this.rightData, this.rightCheckedData);
      this.resetData();
    },

    // 将非应急企业 → 非应急企业
    handleUnbind() {
      if (!this.leftCheckedData.length) {
        this.$message.warning("请选择待邀请应急企业数据");
        return;
      }
      this.dataMove(this.rightData, this.leftCheckedData);
      this.itselfDelete(this.leftData, this.leftCheckedData);
      this.resetData();
    },

    // 重置左右下拉树恢复初始状态
    resetData() {
      this.$nextTick(() => {
        this.$refs.departmentTree.setAllNodeCheck(false);
        this.$refs.departRightTree.setAllNodeCheck(false);
        this.resetLeft();
        this.resetRight();
        this.leftDataTotal = this.$refs.departmentTree.getAllNodes(
          false,
          false
        ).data.length;
        this.rightDataTotal = this.$refs.departRightTree.getAllNodes(
          false,
          false
        ).data.length;
      });
    },

    // 数据移动添加
    dataMove(data, checkData) {
      data.forEach(item => {
        checkData.forEach(list => {
          if (item.id === list.pid) {
            item.children.push(list);
          }
        });
        if (item.children && item.children.length) {
          this.dataMove(item.children, checkData);
        }
      });
    },

    // 数据过滤删除
    itselfDelete(data, checkData) {
      data.forEach(item => {
        checkData.forEach(list => {
          if (item.id === list.pid) {
            const listIndex = item.children.findIndex(
              child => child.id === list.id
            );
            if (listIndex !== -1) item.children.splice(listIndex, 1);
          }
        });

        if (item.children && item.children.length) {
          this.itselfDelete(item.children, checkData);
        }
      });
    },

    // 提交数据之前格式化数据
    handleSubmit() {
      this.leftCheckedData = [];
      this.$refs.departmentTree.setAllNodeCheck(false);
      this.leftIndeterminate = false;
      this.leftCheckedAll = false;
      let data = this.$refs.departmentTree.getAllNodes(false, false).data;
      if (data.length < 1) {
        this.$message.warning("请选择企业");
        return;
      }
      let ids = data.map(item => {
        return { comparyId: item.id, countyId: item.pid, countyName: item.pid };
      });
      this.saveData(ids);
    },

    async saveData(ids) {
      try {
        this.loading = true;
        let { code, message } = await saveCompanyData({
          emergencyCompanySaveVOList: ids
        });
        if (code === 1) {
          this.$message.success(message);
          this.$router.push("emergencyManageCompanyList");
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/deparment.scss";
.department-manage {
  height: 100%;
  .add-department-wrapper,
  .edit-department-wrapper {
    padding: 20px 30px 20px 15px;
    /deep/.el-form-item__content {
      .higher-department-tree {
        .sub-selected-val {
          border: 1px solid #f56c6c;
        }
      }
      .el-select {
        width: 237px;
      }
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/deparment-popper.scss";
</style>
